
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { authService } from '../../../services';
import { SEARCH_QUERY } from '../../queries/SEARCH_QUERY';
import { useAuthState } from '../../../hooks/auth';
import { useMinimalSearchLazyQuery, useSearchLazyQuery } from './useSearchLazyQuery';

export const COMPONENT_LIST_TYPES = {
    HOMEPAGE: 'HOMEPAGE_SETUP',
};

const defaultOptions = {
    useMinSearch: false,
};

export function useComponentListsQuery( listType, _options = {} ) {

    const options = { ...defaultOptions, ..._options };

    const { claims } = useAuthState();

    const { data: componentData, loading: componentLoading } = useQuery( SEARCH_QUERY, { variables: { types: [ 'component_list_sets' ], sort: 'createdAt', order: 'desc', personId: authService.isAdminUser() ? undefined : claims.person_id } } );
    const [ minSearchQuery, { data: minSearchData } ] = useMinimalSearchLazyQuery( );
    const [ searchQuery, { data: searchData } ] = useSearchLazyQuery( {}, false, false );

    const [ componentListSpecs, setComponentListSpecs ] = useState();
    const [ componentList, setComponentList ] = useState();
    const [ data, setData ] = useState();
    const [ loading, setLoading ] = useState( true );

    useEffect( () => {
        let listSet;

        if ( componentLoading ) {
            return;
        }

        if ( !componentData 
            || !( componentData?.search?.edges?.length > 0 ) 
            || !( listSet = componentData.search.edges.filter( e => e.node.type == listType )?.[ 0 ].node ) ) { 
            setLoading( false );
            return;
        }

        const courseList = listSet.componentLists.find( l => l.type == 'COURSES' )?.uuids ?? [];
        const currList = listSet.componentLists.find( l => l.type == 'CURRICULUMS' )?.uuids ?? [];
        const allIds = [ ...courseList, ...currList ];

        setComponentListSpecs( {
            all: allIds,
            courses: courseList,
            curriculums: currList,
        } );

        setComponentList( listSet );

        const query = options.useMinSearch ? minSearchQuery : searchQuery;

        query( {
            types: [ 'courses', 'curricula' ],
            page: 1,
            limit: allIds.length, 
            ids: allIds
        } );

    }, [ componentData, componentLoading ] );

    useEffect( () => {
        if ( ( !searchData && !minSearchData ) || !componentListSpecs ) {
            return;
        }

        const data = options.useMinSearch ? minSearchData : searchData;

        setData( {
            all: data,
            courses: componentListSpecs.courses.map( id => data.find( s => s.id == id ) ).filter( c => !!c ),
            curriculums: componentListSpecs.curriculums.map( id => data.find( s => s.id == id ) ).filter( c => !!c ),
        } );

        setLoading( false );
    }, [ searchData, minSearchData, componentListSpecs ] );


    return useMemo ( () => ( {
        data,
        componentList, 
        loading: loading
    } ), [ data, componentList, loading ] );
}